import ReactHtmlParser from 'react-html-parser'
import DOMPurify from 'dompurify'
import { lazy } from 'react'

// 원산지 10자 초과 시 문자열 대체
export const migrOrinatNmReplace = (value) => {
  if (value === null || value === undefined || value === '') {
    return ''
  }

  try {
    if (value.length > 10) {
      return '상세 참조'
    } else {
      return value
    }
  } catch (e) {
    return value
  }
}

/**
 * 파일 확장자 체크
 * @param {*} files
 * @returns
 */
export const validFileExt = (files) => {
  const exts = ['txt', 'jpg', 'jpeg', 'gif', 'png', 'doc', 'ppt', 'xls', 'pptx', 'docx', 'xlsx', 'pdf']
  let isValid = true
  for (let i = 0; i < files.lenght; i++) {
    for (let j = 0; j < exts.length; j++) {
      if (files[i].name.indexOf(isValid[j]) === -1) {
        isValid = false
        break
      }
    }
  }

  return isValid
}

/**
 * 문자열 유효성체크
 * @param {*} data
 * @returns
 */
export const isEmptyString = (val) => {
  if (val === undefined || val === 'undefined' || val === null || `${val}`.trim() === '') {
    return true
  } else {
    return false
  }
}

/**
 * HashTag 배열생성
 * @param {*} item
 * @returns
 */
export const getHashTag = (item, isDiscount = false) => {
  let result = []
  if (!isEmptyString(item?.siteNm)) {
    //사이트명
    result?.push({ id: 'siteNm', text: item.siteNm, color: 'green' })
  }
  if (item?.phbt || item?.phbtMenuYn === 'Y' || item?.banItem || item?.gdUsSttsCd === '1' || item?.gdUsSttsCd === '2') {
    //금지여부
    result.push({ id: 'phbtMenuYn', text: '금지', color: 'fullred' })
  }
  if (item?.prmtItem || item?.promGdNo) {
    //프로모션
    result.push({ id: 'prmtItem', text: '프로모션', color: 'gray' })
  }
  if (item?.limitProdYn === 'Y' || item?.limitItem) {
    //한정
    result.push({ id: 'limitProdYn', text: '한정', color: 'gray' })
  }
  if ((isDiscount && item?.discItem) || item?.curationDivCd === 'Q10') {
    //할인
    if (
      !(
        item?.newMenuYn === 'Y' ||
        item?.newProdYn === 'Y' ||
        item?.newItem ||
        item?.newOld === 'NEW' ||
        item?.curationDivCd === 'Q20'
      ) &&
      parseInt(item.dcRt) !== 0
    ) {
      result.push({ id: 'mlngCookYn', text: `${parseInt(item.dcRt)}% 할인`, color: 'gray' })
    }
  }
  if (item?.hotItem) {
    //인기
    result.push({ id: 'mlngCookYn', text: '인기', color: 'orange' })
  }
  if (item?.ccFrsCrtYn === 'Y') {
    //프레시
    result.push({ id: 'mlngCookYn', text: '프레시', color: 'gray' })
  }
  if (item?.mlngCookYn === 'Y' || item?.mlngDishYn === 'Y' || item?.mlngDish === '1') {
    //월간메뉴
    result.push({ id: 'mlngCookYn', text: '월간', color: 'gray' })
  }
  if (
    item?.newMenuYn === 'Y' ||
    item?.newProdYn === 'Y' ||
    item?.newItem ||
    item?.newOld === 'NEW' ||
    item?.curationDivCd === 'Q20'
  ) {
    //신규메뉴
    result.push({ id: 'newMenuYn', text: 'NEW', color: 'fullgreen' })
  }
  if (
    item?.type === '1' ||
    item?.crtType === 'STD' ||
    item?.crtType === '1' ||
    item?.siteRpNm === '표준' ||
    item?.refrMenuYn === 'Y'
  ) {
    //표준메뉴 여부
    result.push({ id: 'typt', text: '표준', color: 'gray' })
  }

  return result
}

export const stringToDate = (dateStr) => {
  if (!isEmptyString(dateStr)) {
    let date = dateStr.replace(/-/g, '').replace(/\./gi, '')
    if (date.length > 8) {
      date = date.substring(0, 8)
    }
    return new Date(date.substring(0, 4), parseInt(date.substring(4, 6)) - 1, date.substring(6, 8))
  }
  return new Date()
}

const regHTML = /<[^>]*>?/gi
// 미리보기용 description 필터
export const descriptionFilter = (description) =>
  ReactHtmlParser(DOMPurify.sanitize(description, { FORBID_TAGS: ['img'] }))
    ?.filter((fItem) => fItem.props.children && fItem.props.children.toString().trim() !== '')
    ?.filter((_, fIdx) => fIdx < 1)

// editor contents unescape
export const replaceBeforeEscape = (contents) => {
  const regex1 = /&lt;script&gt;/gi
  const regex2 = /&lt;\/script&gt;/gi
  const regex3 = /&lt;/gi
  const regex4 = /&gt;/gi
  const regex5 = /&amp;/gi
  const regex6 = /&quot;/gi
  const regex7 = /&plusmn;/gi

  const subScriptStartTag = (data) => data?.replaceAll(regex1, '###')
  const subScriptEndTag = (data) => data?.replaceAll(regex2, '&&&')
  const lessEscape = (data) => data?.replaceAll(regex3, '<')
  const greaterEscape = (data) => data?.replaceAll(regex4, '>')
  const ampEscape = (data) => data?.replaceAll(regex5, '&')
  const quotEscape = (data) => data?.replaceAll(regex6, '')
  const repScriptStartTag = (data) => data?.replaceAll('###', '&lt;script&gt;')
  const repScriptEndTag = (data) => data?.replaceAll('&&&', '&lt;/script&gt;')
  const plusMinusEscape = (data) => data?.replaceAll(regex7, '±')
  const newlineToBr = (data) => data?.replaceAll(/\\n/g, '<br>')

  return pipe(
    subScriptStartTag,
    subScriptEndTag,
    lessEscape,
    greaterEscape,
    ampEscape,
    repScriptStartTag,
    repScriptEndTag,
    quotEscape,
    plusMinusEscape,
    newlineToBr,
  )(contents)
}

const pipe =
  (...funcs) =>
  (v) => {
    return funcs.reduce((res, func) => {
      return func(res)
    }, v)
  }

export const retryLazy = (componentImport) =>
  lazy(async () => {
    const pageAlreadyRefreshed = JSON.parse(window.localStorage.getItem('lazy-Refreshed') || 'false')
    try {
      const component = await componentImport()
      window.localStorage.setItem('lazy-Refreshed', 'false')
      return component
    } catch (error) {
      if (!pageAlreadyRefreshed) {
        window.localStorage.setItem('lazy-Refreshed', 'true')
        return window.location.reload()
      }
      throw error
    }
  })
